module.exports = "<ng-content *ngIf=\"true === selected\"></ng-content>";